import { Card } from "../../ui/Card";

export function PageHeader({ title, subtitle }: { title: string; subtitle?: string }) {
  return (
    <header>
      <h1 className="text-3xl font-medium tracking-tight text-ink">{title}</h1>
      {subtitle && <p className="text-ink-2 mt-1">{subtitle}</p>}
    </header>
  );
}

/**
 * AikoInvite — a Try-this affordance. Clicking dispatches an "aiko:ask"
 * event that AikoBubble listens for: it opens the drawer and seeds the
 * input with the suggestion. The user can edit before sending; Aiko
 * never auto-fires.
 */
export function AikoInvite({ suggestion }: { suggestion: string }) {
  function ask() {
    window.dispatchEvent(new CustomEvent("aiko:ask", { detail: suggestion }));
  }
  return (
    <Card tone="accent">
      <div className="flex items-start gap-3">
        <span aria-hidden className="text-xl">✦</span>
        <div className="flex-1">
          <p className="text-sm text-ink">
            Ask Aiko to render this for you. She reads your real outlets and
            asks before she sends anything.
          </p>
          <p className="mt-2 text-sm text-spinach font-medium">
            "{suggestion}"
          </p>
          <button
            type="button"
            onClick={ask}
            className="mt-3 inline-flex items-center gap-1.5 rounded-md bg-nomni-green text-canvas-2 px-3 py-1.5 text-sm font-medium hover:brightness-110 transition"
          >
            ✦ Try this
          </button>
        </div>
      </div>
    </Card>
  );
}
